<template>
  <v-container fluid class="calc-wrap">
    <div v-if="isLoading" class="text-xs-center py-5">
      <v-progress-circular indeterminate :color="brandColor"></v-progress-circular>
    </div>

    <div v-else class="calc-card">
      <div class="calc-header" :style="{ background: brandColor }">
        <div class="calc-title">Calculadora de Taxas</div>
        <div class="calc-subtitle">Simule quanto você recebe em cada bandeira</div>
      </div>

      <div class="calc-body">
        <label class="calc-label">Valor da venda</label>
        <v-text-field
          v-model.lazy="value"
          v-money="money"
          solo flat hide-details
          background-color="#f4f6f9"
          class="calc-value"
        ></v-text-field>

        <label class="calc-label mt-3">Bandeira</label>
        <v-select
          v-model="selectedBrand"
          :items="brands"
          item-text="name"
          return-object
          prepend-inner-icon="credit_card"
          solo flat hide-details
          background-color="#f4f6f9"
          v-on:change="changeBrand"
        ></v-select>

        <div class="calc-modes">
          <button
            type="button"
            class="calc-mode"
            :class="{ active: mode === 'avista' }"
            :style="mode === 'avista' ? { background: brandColor, borderColor: brandColor } : {}"
            @click="mode = 'avista'"
          >À vista</button>
          <button
            type="button"
            class="calc-mode"
            :class="{ active: mode === 'parcelado' }"
            :style="mode === 'parcelado' ? { background: brandColor, borderColor: brandColor } : {}"
            @click="mode = 'parcelado'"
          >Parcelado</button>
        </div>

        <template v-if="mode === 'parcelado'">
          <label class="calc-label">Parcelas</label>
          <v-select
            v-model="sliceSelected"
            :items="taxes[1]['credit']"
            :return-object="true"
            item-text="name"
            item-value="value"
            solo flat hide-details
            background-color="#f4f6f9"
            v-on:change="getSliceCredit()"
          ></v-select>
        </template>

        <div class="calc-result" :style="{ borderColor: brandColor }">
          <div class="calc-result-label">Você recebe</div>
          <div class="calc-result-value" :style="{ color: brandColor }">
            R$ {{ mode === 'avista' ? getOneCredit() : formatValue(sliceCreditLiquid) }}
          </div>
        </div>

        <div class="calc-inverse">
          <template v-if="mode === 'avista'">
            Para receber esse valor, você deve cobrar
            <b>R$ {{ getOneCreditTransfer() }}</b>
          </template>
          <template v-else-if="sliceSelected.value > 0">
            Para receber esse valor, você deve cobrar
            <b>R$ {{ getSliceCreditTransfer() }}</b>
          </template>
          <template v-else>Selecione as parcelas para simular.</template>
        </div>
      </div>
    </div>
  </v-container>
</template>


<script>
import { mapGetters, mapActions } from "vuex";
import { EventBus } from "@/services/event-bus";
import { VMoney } from "v-money";
import { format } from "path";
export default {
  created() {
    this.$store.dispatch("account/getAccountTaxes");
    const self = this;
  },
  computed: {
    ...mapGetters({
      taxes: "account/accountTaxes",
      isLoading: "account/loading",
      color: "account/color",
      partner: "account/partner",
      brands: "account/accountTaxBrands",
      selectedBrandFromStore: "account/accountTaxSelectedBrand",
    }),
    brandColor() {
      return this.color || "#1976D2";
    },
  },
  watch: {
    selectedBrandFromStore(brand) {
      if (brand) this.selectedBrand = brand;
    },
  },
  data() {
    return {
      value: "",
      tab: null,
      amount: 0,
      oneCreditTaxValue: 0,
      sliceCreditTaxValue: 0,
      oneCreditTaxPercent: 0,
      sliceCreditTaxPercent: 0,
      oneCreditAnticipationValue: 0,
      sliceCreditAnticipationValue: 0,
      oneCreditAnticipationPercent: 0,
      sliceCreditAnticipationPercent: 0,
      oneCreditAllTax: 0,
      sliceCreditAllTax: 0,
      oneCreditLiquid: 0,
      sliceCreditLiquid: 0,
      oneCreditTransferWithdrall: 0,
      sliceCreditTransferWithdrall: 0,
      oneCreditTransferSell: 0,
      sliceCreditTransferSell: 0,
      anticipation_slices: [],
      anticipation_slice: 0,
      anticipation_tax_credit: 0,
      i: 0,
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false,
      },
      sliceSelected: { name: "Selecione", percent: "0", value: 0 },
      selectedBrand: null,
      mode: "avista",
    };
  },
  directives: { money: VMoney },
  methods: {
    changeBrand(brand) {
      const name = brand && brand.name ? brand.name : brand;
      this.$store.dispatch("account/getAccountTaxes", name);
      // Recompute whatever the merchant is currently looking at.
      this.$nextTick(() => {
        this.getOneCredit();
        if (this.sliceSelected && this.sliceSelected.value > 0) this.getSliceCredit();
      });
    },
    getOneCredit() {
      this.amount = Number(this.value.replace(/\D/g, "")) / 100;
      this.oneCreditTaxValue = this.getCreditTaxValue(
        this.amount,
        this.taxes[1]["credit"][0].percent
      );
      this.oneCreditTaxPercent = this.getCreditTaxPercent(1);
      this.oneCreditAnticipationValue = this.getOneCreditAnticipationValue(
        this.amount - this.oneCreditTaxValue
      );
      this.oneCreditLiquid =
        this.amount - this.oneCreditTaxValue - this.oneCreditAnticipationValue;
      this.oneCreditAnticipationPercent = this.getCreditAnticipationPercent(
        this.oneCreditLiquid,
        this.oneCreditTaxPercent
      );
      this.oneCreditAllTax = this.getCreditAllTax(this.oneCreditLiquid);
      return this.formatValue(this.oneCreditLiquid);
    },
    getSliceCredit() {
      this.sliceCreditTaxValue = this.getCreditTaxValue(
        this.amount,
        this.taxes[1]["credit"][this.sliceSelected.value - 1].percent
      );
      this.sliceCreditTaxPercent = this.getCreditTaxPercent(
        this.taxes[1]["credit"][this.sliceSelected.value - 1].value
      );
      this.sliceCreditAnticipationValue = this.getSliceCreditAnticipationValue(
        this.amount - this.sliceCreditTaxValue
      );
      this.sliceCreditLiquid =
        this.amount -
        this.sliceCreditTaxValue -
        this.sliceCreditAnticipationValue;
      this.sliceCreditAnticipationPercent = this.getCreditAnticipationPercent(
        this.sliceCreditLiquid,
        this.sliceCreditTaxPercent
      );
      this.sliceCreditAllTax = this.getCreditAllTax(this.sliceCreditLiquid);
    },
    getCreditTaxValue(amount, tax) {
      return (amount * Number(tax)) / 100;
    },
    getCreditTaxPercent(slice) {
      if (this.amount > 0) {
        return this.taxes[1]["credit"][slice - 1].percent;
      } else return 0;
    },
    getOneCreditAnticipationValue(amount) {
      if (this.amount > 0) {
        return (amount * Number(this.taxes[2]["anticipation"])) / 100;
      } else return 0;
    },
    getSliceCreditAnticipationValue(amount) {
      if (this.amount > 0) {
        this.getSlices(amount);
        this.getAnticipation_tax();
        return this.anticipation_tax_credit;
      } else return 0;
    },
    getSlices(amount) {
      this.anticipation_slices = [];
      for (var x = 1; x <= 12; x++) {
        this.anticipation_slices.push(
          (amount / this.sliceSelected.value) *
            (this.formatPercent(Number(this.taxes[2]["anticipation"])) * x)
        );
      }
    },
    getAnticipation_tax() {
      this.i = 1;
      this.anticipation_slice = 0;
      this.anticipation_tax_credit = 0;
      this.anticipation_slice = 0;
      while (this.i <= this.sliceSelected.value) {
        this.anticipation_slice = this.anticipation_slices[this.i - 1];
        this.anticipation_tax_credit =
          this.anticipation_tax_credit + this.anticipation_slice;
        this.i++;
      }
    },
    getCreditAnticipationPercent(amount, creditPercent) {
      if (this.amount > 0) {
        let calc = ((1 - amount / this.amount) * 100 - creditPercent).toPrecision(2)
        if (calc.includes('e')) calc = 0
        return calc;
      } else return 0;
    },
    formatPercent(value) {
      return value / 100;
    },
    getCreditAllTax(valueLiquid) {
      if (this.amount > 0) {
        return 1 - valueLiquid / this.amount;
      } else return 0;
    },
    getOneCreditTransfer() {
      if (this.amount > 0) {
        this.oneCreditTransferSell = this.amount / (1 - this.oneCreditAllTax);
        this.oneCreditTransferWithdrall = this.formatValue(
          this.oneCreditTransferSell -
            this.oneCreditTransferSell * this.oneCreditAllTax
        );
        return this.formatValue(this.oneCreditTransferSell);
      } else return 0;
    },
    getSliceCreditTransfer() {
      if (this.sliceSelected.value > 0) {
        this.sliceCreditLiquid =
          this.amount -
          this.sliceCreditTaxValue -
          this.sliceCreditAnticipationValue;
        this.sliceCreditTransferSell =
          this.amount / (1 - this.sliceCreditAllTax);
        this.sliceCreditTransferWithdrall = this.formatValue(
          this.sliceCreditTransferSell -
            this.sliceCreditTransferSell * this.sliceCreditAllTax
        );
        return this.formatValue(this.sliceCreditTransferSell);
      } else return 0;
    },
    formatValue(value) {
      return value.toLocaleString("pt-BR", {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      });
    },
  },
  components: {},
};
</script>

<style scoped>
.calc-wrap {
  display: flex;
  justify-content: center;
  padding: 24px 12px;
}
.calc-card {
  width: 100%;
  max-width: 460px;
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 12px 40px rgba(20, 30, 60, 0.12);
  overflow: hidden;
}
.calc-header {
  padding: 28px 24px;
  color: #ffffff;
  text-align: center;
}
.calc-title {
  font-size: 22px;
  font-weight: 700;
  letter-spacing: 0.2px;
}
.calc-subtitle {
  font-size: 13px;
  opacity: 0.85;
  margin-top: 4px;
}
.calc-body {
  padding: 24px;
}
.calc-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #8a94a6;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  margin: 12px 0 6px;
}
.calc-value >>> input {
  font-size: 26px;
  font-weight: 700;
  color: #1f2733;
  text-align: center;
}
.calc-value >>> .v-input__slot,
.calc-body >>> .v-select .v-input__slot {
  border-radius: 12px !important;
}
.calc-modes {
  display: flex;
  gap: 10px;
  margin: 20px 0 4px;
}
.calc-mode {
  flex: 1;
  padding: 12px 0;
  border: 1.5px solid #e2e6ee;
  border-radius: 12px;
  background: #f4f6f9;
  color: #6b7688;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.15s ease;
}
.calc-mode.active {
  color: #ffffff;
}
.calc-result {
  margin-top: 22px;
  border: 2px solid;
  border-radius: 16px;
  padding: 20px;
  text-align: center;
  background: #fafbfd;
}
.calc-result-label {
  font-size: 13px;
  color: #8a94a6;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.calc-result-value {
  font-size: 38px;
  font-weight: 800;
  margin-top: 6px;
  line-height: 1.1;
}
.calc-inverse {
  margin-top: 16px;
  text-align: center;
  font-size: 14px;
  color: #6b7688;
}
.calc-inverse b {
  color: #1f2733;
}
</style>
